import {
  InsiderSlimBannerContainer,
  useCanRender,
} from "@faire/retailer-visitor-shared/components/InsiderSlimBanner/InsiderSlimBannerContainer";
import { withPriority } from "@faire/retailer-visitor-shared/components/PriorityRenderer/withPriority";

export const InsiderSlimBanner = withPriority(
  InsiderSlimBannerContainer,
  useCanRender
);
